export const electricBlue = '#0071e3';
export const hoverBlue = '#0e99ff';
export const concordBlue = '#002f69';
export const lightBlue = '#638bbf';
export const lighterBlue = '#7ba7de';
export const lightestBlue = '#d7e6f6';
export const black = '#000';
export const graphite = '#333';
export const lightGraphite = '#555';
export const smoke = '#888';
export const lightSmoke = '#bbb';
export const gray = '#ddd';
export const lightGray = '#f2f2f2';
export const silver = '#f9f9f9';
export const white = '#fff';
export const successGreen = '#199953';
export const lightGreen = '#e8f7ed';
export const darkYellow = '#ac6f0b';
export const warningYellow = '#f5a623';
export const lightYellow = '#fff3cd';
export const warningRed = '#d0011b';
export const lightRed = '#f7d5d9';
